import c from "emoji-mart-vue-fast/data/all.json";
import { EmojiIndex as i, frequently as r } from "emoji-mart-vue-fast";
/**
 * @copyright Copyright (c) 2021 Jonas Meurer <jonas@freesources.org>
 *
 * @author Jonas Meurer <jonas@freesources.org>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
const m = function(e, t = 10) {
  const o = new i(c);
  if (e) {
    let n = o.search(`:${e}`, t);
    return n.length < t && (n = n.concat(o.search(e, t - n.length))), n;
  }
  return r.get(t).map((n) => o.emoji(n)) || [];
}, a = function(e) {
  r.add(e);
};
export {
  a as emojiAddRecent,
  m as emojiSearch
};
